import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const ConfirmVideoUploadModal = ({showConfirmUpload, handleUploadConfirmation}) => {
    return (
        <Modal
            backdrop="static"
            centered
            size="md"
            show={showConfirmUpload}
            onHide={() => handleUploadConfirmation(false)}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <h3>
                        Confirm Upload
                    </h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body  >
                <strong>Warning</strong>: This action will delete your current video.
                Once replaced, the old video cannot be recovered.
                <br/><br/>
                Do you want to proceed with the upload?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => handleUploadConfirmation(false)}>Close</Button>
                <Button variant="danger" onClick={() => handleUploadConfirmation(true)}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    )
}
export default ConfirmVideoUploadModal;